import { ProjectWizardContext } from 'context/Context';
import { useContext } from 'react';
import { Alert } from 'react-bootstrap';
import { FiAlertCircle } from 'react-icons/fi';
import StepsStatusWizard from 'sites/admin/inmobiliario/gestionarPropiedades/common/StepsStatusWizard';

export const InfoWizard = () => {
  const { stepStatus } = useContext(ProjectWizardContext);

  return (
    <>
      <div className="my-4">
        <Alert variant="info">
          <p className="mb-0">
            <FiAlertCircle /> <strong>¡Atención!</strong> No pierda de vista la
            calidad del aviso, es importante que esté completo.
          </p>
        </Alert>

        <StepsStatusWizard project={stepStatus} />
      </div>

      <hr className="text-400" />

      <p className="small">
        Todos los campos con asterisco (<span className="text-danger">*</span>)
        son obligatorios.
      </p>
    </>
  );
};
